import { Col, Row } from "@payping/web-components";
import React, { useState } from "react";
import BlogCard from "./BlogCard";
import NotificationCard from "./NotificationCard";

const NotifBlogCard: React.FC = () => {
  const [showBlogPost, setShowBlogPost] = useState(true);

  const { loading: blogLoading, value: blogData } = BlogCard.useBlogPost();

  return (
    <Row gutter={[0, showBlogPost ? 16 : 0]} style={{ marginBottom: 0, width: "100%" }}>
      <Col span={24}>
        <NotificationCard setShowBlogPost={(value) => setShowBlogPost(value)} />
      </Col>
      {showBlogPost && (
        <Col span={24} style={{ paddingBottom: 0 }}>
          <BlogCard loading={blogLoading} value={blogData} />
        </Col>
      )}
    </Row>
  );
};

export default NotifBlogCard;
